import React from "react";
import { Route, Routes } from "react-router-dom";
import HomePage from "./pages/HomePage";
import AppsPage from "./pages/AppsPage";
import AppDetailPage from "./pages/AppDetailPage";
import LegalPage from "./pages/LegalPage";
import PolicyPage from "./pages/PolicyPage";
import SupportPage from "./pages/SupportPage";
import DeleteAccountPage from "./pages/DeleteAccountPage";
import NotFoundPage from "./pages/NotFoundPage";
import PrinciplesPage from "./pages/PrinciplesPage";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/principles" element={<PrinciplesPage />} />
      <Route path="/apps" element={<AppsPage />} />
      <Route path="/apps/:slug" element={<AppDetailPage />} />
      <Route path="/apps/:slug/privacy" element={<PolicyPage kind="privacy" />} />
      <Route path="/apps/:slug/terms" element={<PolicyPage kind="terms" />} />
      <Route path="/apps/:slug/support" element={<SupportPage />} />
      <Route path="/apps/:slug/delete-account" element={<DeleteAccountPage />} />
      <Route path="/legal" element={<LegalPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
